import { Component, Input, OnInit, signal } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { LeaderboardAppointment, LeaderboardClient } from '../../services/ppv.api'
import { MatDialog } from '@angular/material/dialog'
import { ClientVerificationModalComponent } from '../client-verification-modal/client-verification-modal.component'
import { Overlay } from '@angular/cdk/overlay'

@Component({
   selector: 'vc-client-verification-card',
   templateUrl: './client-verification-card.component.html',
   styleUrls: ['./client-verification-card.component.scss'],
   standalone: false,
})
export class ClientVerificationCardComponent {
   @Input() practiceSKey: number = 0
   @Input() percent: number = 0

   subtext: string = 'clients verified'

   appointments: LeaderboardAppointment[] = []

   handleClick(): void {
      // Stub: implement behavior later
      console.log(`Clicked card with percent: ${this.percent}%`)
      console.log('practiceSKey: ' + this.practiceSKey)

      this.openMeetingSchedulerModal()
   }
   constructor(private route: ActivatedRoute, private dialog: MatDialog, private overlay: Overlay) {}

   openMeetingSchedulerModal(): void {
      this.dialog.open(ClientVerificationModalComponent, {
         panelClass: 'modal-side-drawer-panel',
         autoFocus: false,
         scrollStrategy: this.overlay.scrollStrategies.noop(),
         data: { practiceSKey: this.practiceSKey },
      })
   }
}
